import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "basecolor-mr mb-2" };
var _hoisted_2 = ["placeholder", "value"];
var _hoisted_3 = { class: "text-red-500 mb-2 w-48" };
var _hoisted_4 = { class: "text-red-500 mb-2 w-48" };
import { ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BaseInput',
    props: {
        label: String,
        placeholder: String,
        modelValue: String,
        Number: Number,
        errorMessage: String,
        isInputValid: String,
    },
    setup: function (__props) {
        var props = __props;
        var errorMessage = ref("");
        function validator(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();
                errorMessage.value = "Non sono ammessi numeri negativi e lettere. Inserisci un numero positivo.";
            }
            else {
                errorMessage.value = "";
                return true;
            }
        }
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("label", _hoisted_1, _toDisplayString(__props.label), 1),
                _createElementVNode("input", _mergeProps({
                    class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-64 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 basecolor-mr",
                    placeholder: __props.placeholder,
                    value: __props.modelValue,
                    onInput: _cache[0] || (_cache[0] = function ($event) { return (_ctx.$emit('update:modelValue', $event.target.value)); }),
                    onKeypress: validator,
                    onKeyup: _cache[1] || (_cache[1] = function ($event) { return (_ctx.$emit('validateInput')); })
                }, _ctx.$attrs, {
                    required: "",
                    min: "0"
                }), null, 16, _hoisted_2),
                _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(errorMessage)), 1),
                _createElementVNode("p", _hoisted_4, _toDisplayString(__props.isInputValid), 1)
            ], 64));
        };
    }
});
